import { render, staticRenderFns } from "./SalesReportsFile.vue?vue&type=template&id=3655c594"
import script from "./SalesReportsFile.vue?vue&type=script&lang=js"
export * from "./SalesReportsFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports